export const DiscountTypes = [
  {
    value: 'percentage',
    label: 'Promocode.Discount.Percentage'
  },
  {
    value: 'flat',
    label: 'Promocode.Discount.Flat'
  }
]
export const PAYABLE_TYPES = [
  { value: 'App\\Models\\Service', label: 'Promocode.PayableType.Service' },
  { value: 'App\\Models\\Plan', label: 'Promocode.PayableType.Plan' }
]